
(function() {
  // Native lazy loading fallback for older browsers
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[data-lazy-src]');

    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.lazySrc;
          img.removeAttribute('data-lazy-src');
          observer.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // Enable native lazy loading where supported
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    if (!img.hasAttribute('loading')) {
      img.setAttribute('loading', 'lazy');
    }
  });
})();
